/* eslint-disable new-cap */
import Cookies from "js-cookie";
import moment from "moment";
import {selectMediakitUser} from "./../features/stores/mediakitUser.slice";
import {useSelector} from "react-redux";
import {socialMediaLinks} from "../constants/socialMedia";

export const numberFollowerFormat = (followers: number) => {
  return Intl.NumberFormat( 'en-US', {maximumFractionDigits: 2, notation: 'compact', compactDisplay: 'short'}).format(followers);
};

export const getUniqueGlobalFollowerCount = (linksSection: Array<any>) => {
  if (!Array.isArray(linksSection)) {
    return 0;
  } else {
    const linkHash: any = {};
    let count = 0;
    linksSection.map((ele: any, index: number) => {
      ele.linksSectionItems.map((item: any, itemIndex: number) => {
        const url = item.url.split('?')[0];
        if (!linkHash[url]) {
          linkHash[url] = !!item.followersCount;
          count += item.followersCount != null ? item.followersCount : 0;
        }
      });
    });
    return count;
  }
};

export const getDateFromRange = (range: any) => {
  switch (range) {
    case 'Last 7 days':
      return [moment().subtract(7, 'd').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
    case 'This Month':
    case 'Month':
       return [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
    case 'Last Month':
        return [moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'), moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')];
    case 'Last Quarter':
        return [moment().quarter(moment().quarter()).startOf('quarter').format('YYYY-MM-DD'), moment().quarter(moment().quarter()).endOf('quarter').format('YYYY-MM-DD')];
    case 'This Year':
        return [moment().startOf('years').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
    case 'Last Year':
          return [moment().subtract(1, 'years').startOf('year').format('YYYY-MM-DD'), moment().subtract(1, 'years').endOf('year').format('YYYY-MM-DD')]; 
    case 'Week':
          return [moment().startOf('isoWeek'), moment().endOf('isoWeek')];  
    case 'Last 30d':
          return [moment().subtract(30, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
    case 'Today':
          return [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
    case 'All time':
          return [moment('2020-01-01').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
    default:
      return [moment(), moment()];  
  }
};

export const isProdSite = () => {
  return window.location.host == 'alfan.link';
};

export const removeStepCookie = () => {
  Cookies.remove('step');
};


export const mediakitUserExist = () => {
  const mediakitUser = useSelector(selectMediakitUser) as any;
  return mediakitUser?.id === 'new-mediakit' ? false : true;
};

export const isLocalhost = () => {
  return window?.location?.hostname === "localhost";
};

export const extendUrl = (data:any)=>{
  const {type, url} = data;
  if (!url) return url;
  const socialMediaDetails = socialMediaLinks.find((item)=>item.key === type);
  if (!socialMediaDetails) return url;

  const usedTemplate = socialMediaDetails.linkTemplates.find((item)=>{
    return url.includes(item);
  });

  if (usedTemplate) return url;
  const template = socialMediaDetails.linkTemplates[0];
  if (type === 'youtube') return template + '.com/' + url;
  else if (type === 'tiktok') return template + '/@' + url;
  else if (type === 'snapchat') return template + '/@' + url;
  return template + '/' + url;
};

export const groupBy = (array: any, key: string) => {
  return array.reduce((result: any, currentValue: any) => {
    (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
    return result;
  }, {});
};
